import React, { useState, useEffect } from "react";
import toastr from "toastr";
import { authFetch } from "../utils/authFetch";

function Role() {
  const [roleForm, setRoleForm] = useState({ name: "", slug: "" });
  const [roles, setRoles] = useState([]);
  const [editingId, setEditingId] = useState(null);
  const [loading, setLoading] = useState(false);

  const fetchRoles = async () => {
    try {
      const res = await authFetch("/api/v1/role/list", {
        // headers: {
        //   Authorization: `Bearer ${localStorage.getItem("token")}`,
        // },
      });
      const data = await res.json();
      setRoles(Array.isArray(data) ? data : []);
    } catch {
      showToast("Failed to fetch roles", "error");
    }
  };

  useEffect(() => {
    fetchRoles();
  }, []);

  const showToast = (message, type = "success") => {
    toastr.options = {
      closeButton: true,
      progressBar: true,
      positionClass: "toast-top-right",
      timeOut: "3000",
    };
    toastr[type](message);
  };

  const handleCreateOrUpdateRole = async () => {
    if (!roleForm.name.trim() || !roleForm.slug.trim()) {
      showToast("Name and slug are required", "error");
      return;
    }

    setLoading(true);
    const url = editingId
      ? "/api/v1/role/update"
      : "/api/v1/role/create";
    const method = editingId ? "PUT" : "POST";

    try {
      const res = await authFetch(url, {
        method,
        // headers: {
        //   "Content-Type": "application/json",
        //   Authorization: `Bearer ${localStorage.getItem("token")}`,
        // },
        body: JSON.stringify({
          ...roleForm,
          id: editingId,
        }),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.detail || "Something went wrong");

      showToast(editingId ? "Role updated" : "Role created", editingId ? "info" : "success");
      setRoleForm({ name: "", slug: "" });
      setEditingId(null);
      fetchRoles();
      document.querySelector("#exampleModal .btn-close").click();
    } catch (err) {
      showToast(err.message, "error");
    } finally {
      setLoading(false);
    }
  };

  const handleEdit = (role) => {
    setRoleForm({ name: role.name, slug: role.slug });
    setEditingId(role.id);
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete this role?")) return;

    try {
      const res = await authFetch(`/api/v1/role/delete/${id}`, {
        method: "DELETE",
        // headers: {
        //   Authorization: `Bearer ${localStorage.getItem("token")}`,
        // },
      });

      const data = await res.json();
      if (!res.ok) throw new Error(data.detail || "Delete failed");

      showToast("Role deleted", "error");
      fetchRoles();
    } catch (err) {
      showToast(err.message, "error");
    }
  };

  const handleChange = (e) => {
    setRoleForm({ ...roleForm, [e.target.name]: e.target.value });
  };

  return (
    <div className="page-wrapper">
      <div className="page-content-wrapper">
        <div className="page-content">
          <div className="card">
            <div className="card-body">
              <div className="card-title d-flex justify-content-between align-items-center">
                <h4 className="mb-0">Role Manager</h4>
                <button
                  className="btn btn-primary"
                  data-bs-toggle="modal"
                  data-bs-target="#exampleModal"
                  onClick={() => {
                    setRoleForm({ name: "", slug: "" });
                    setEditingId(null);
                  }}
                >
                  Add
                </button>
              </div>

              {/* Modal */}
              <div className="modal fade" id="exampleModal" tabIndex="-1" aria-hidden="true">
                <div className="modal-dialog">
                  <div className="modal-content">
                    <div className="modal-header">
                      <h5 className="modal-title">{editingId ? "Edit Role" : "Add Role"}</h5>
                      <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div className="modal-body">
                      <label class="form-label">Role Name</label>
                      <input
                        name="name"
                        placeholder="Role Name"
                        className="form-control mb-2"
                        value={roleForm.name}
                        onChange={handleChange}
                      />
                      <label class="form-label">Display Name</label>
                      <input
                        name="slug"
                        placeholder="Role Slug"
                        className="form-control mb-2"
                        value={roleForm.slug}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="modal-footer">
                      <button className="btn btn-secondary" data-bs-dismiss="modal">
                        Close
                      </button>
                      <button
                        className="btn btn-primary"
                        onClick={handleCreateOrUpdateRole}
                        disabled={loading}
                      >
                        {loading ? "Saving..." : editingId ? "Update" : "Save"}
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              {/* Table */}
              <hr />
              <div className="table-responsive">
                <table className="table table-striped table-bordered">
                  <thead>
                    <tr>
                      <th>ID</th>
                      <th>Name</th>
                      <th>Slug</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {roles.length === 0 && (
                      <tr>
                        <td colSpan="3" className="text-center">
                          No Roles found
                        </td>
                      </tr>
                    )}
                    {roles.map((role,i) => (
                      <tr key={role.id}>
                        <td>{i + 1}</td> 
                        <td>{role.name}</td>
                        <td>{role.slug}</td>
                        <td>
                          <button
                            className="btn btn-sm btn-info me-2"
                            data-bs-toggle="modal"
                            data-bs-target="#exampleModal"
                            onClick={() => handleEdit(role)}
                          >
                            <span class="bx bx-edit"></span>
                          </button>
                          {/* <button className="btn btn-sm btn-danger" onClick={() => handleDelete(role.id)}>
                            <span class="bx bx-trash"></span>
                          </button> */}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Role;
